//@import dependencies
import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import CategoryCardComponent from 'app_components/commons/categorycard'
import CategoryModuleSkeleton from 'app_components/modules/academic/categories/components/categoriesModuleSkeleton';
import AlertComponent from 'app_components/commons/alert';
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import ModularService from 'app_services/admin/modular/modularService';
// @end

// @INFO Import Styles
import './../categoriesModule.scss'

// @ADD Component types
interface ICategoriesModuleLayoutProps {
  container: string;
  currentCategory?: string
  onHandleCategory?: (category: any) => void
}

const CategoriesModuleLayout: React.FC<ICategoriesModuleLayoutProps> = (props) => {

  const offertIcontec = require('app_assets/images/logos/offert_icontec.png')
  const modularService: ModularService = new ModularService()

  const [listOfModulars, setListOfModulars] = useState<Array<any>>([])
  const [loading, setLoading] = useState<boolean>(true)

  const { t } = useTranslation()

  useEffect(() => {
    getModulares()
  }, [])

  const getModulares = async () => {
    let modulares: Array<any> = []
    const modularesResponse = await modularService.listExternal({moodle_id: true})
    if (modularesResponse) {
      modulares = modularesResponse.modulars
    }
    setListOfModulars(modulares)
    setLoading(false)
  }

  const getCategoryClass = (index: number) => {
    return `azul${(index%3)+1}`
  }

  const onHandleCategory = (category: any): void => {
    if (props.onHandleCategory) props.onHandleCategory(category)
  }

  return(
    <div className={`categories-banner ${props.container}`}>
      <div
        className='categories-banner--image'
        style={{ background: `url(${offertIcontec})` }}
      />
      <div className="container-fluid">
        <div className={'Atomtextodesplegable'}>
          <span className={'titulo'}>Tienda</span>
        </div>
        {loading ? (
          <CategoryModuleSkeleton />
        ) : (
          <>
            {listOfModulars.length > 0 ? (
              <div className={'content-categories'}>
                {listOfModulars.map((modular, index) => (
                  <div className="category-container" onClick={() => onHandleCategory(modular)}>
                    <CategoryCardComponent
                      aditionalClass={getCategoryClass(index)}
                      categorie={modular.name}
                      active={props.currentCategory === modular._id}
                    />
                  </div>
                ))}
              </div>
            ): (
                <AlertComponent
                  type='info'
                  title={'No hay categorias disponibles'}
                />
            )}
          </>
        )}

      </div>
    </div>
  )
}

export default CategoriesModuleLayout
